<div *ngIf="formGroup" [formGroup]="formGroup">
	<mat-form-field>
		<mat-label>
			<ng-content></ng-content>
		</mat-label>
		<mat-chip-grid
			#fileList
			[errorStateMatcher]="customErrorStateMatcher"
			[formControl]="formControl"
			[attr.aria-label]="
				'Attached files' | cmLocalize: locFeature + '/System.FileUpload.Title.AttachedFiles'
			">
			<mat-chip-row
				*ngFor="let file of value; index as i"
				(removed)="remove(i)"
				[disableRipple]="true"
				[removable]="true"
				[editable]="false"
				[disabled]="isDisabled">
				{{ file.name }}
				<button
					matChipRemove
					type="button"
					[matTooltip]="
						'Remove' | cmLocalize: locFeature + '/System.FileUpload.Button.RemoveFile'
					"
					[attr.aria-label]="
						('Remove'
							| cmLocalize: locFeature + '/System.FileUpload.Button.RemoveFile') +
						' ' +
						file.name
					">
					<ats-icon name="circle-close"> </ats-icon>
				</button>
			</mat-chip-row>
		</mat-chip-grid>
		<input
			[ngClass]="{ 'cdk-visually-hidden': value?.length }"
			matInput
			[matChipInputFor]="fileList"
			[required]="required"
			readonly
			[attr.aria-label]="
				'Press the spacebar or click the following button to open the file dialog'
					| cmLocalize: locFeature + '/System.FileUpload.FieldHint.FileInstructions'
			"
			(keydown.space)="fileInput.click()"
			(click)="fileInput.click()"
			[disabled]="isDisabled" />
		<button
			type="button"
			matSuffix
			mat-button
			(click)="fileInput.click()"
			[disabled]="isDisabled">
			<ng-container *ngIf="!multiple; else multipleBtn">
				<span [cmLocalize]="locFeature + '/System.FileUpload.Button.SelectFile'">
					Select File
				</span>
			</ng-container>
			<ng-template #multipleBtn>
				<span [cmLocalize]="locFeature + '/System.FileUpload.Button.SelectFiles'">
					Select Files
				</span>
			</ng-template>
		</button>
		<input
			type="file"
			class="hide-input"
			#fileInput
			(change)="attachFile($event)"
			[accept]="acceptedFileTypes"
			[required]="required"
			[multiple]="multiple" />
		<mat-hint>
			<ng-content select="[file-upload-hints]"></ng-content>
		</mat-hint>
		<mat-error *ngIf="control.invalid && (control.touched || control.dirty)">
			<ng-content select="[file-upload-errors]"></ng-content>
		</mat-error>
	</mat-form-field>
	<ng-content select="[existing-files]"></ng-content>
</div>
